import { useState, useEffect } from 'react';

// Cache module-level — un seul fetch pour toute l'app
let _cache = null;

export function useFluoVehicles() {
    const [data, setData] = useState(_cache);

    useEffect(() => {
        if (_cache) return;
        fetch('/api/fluo-vehicles')
            .then(r => r.json())
            .then(d => { _cache = d; setData(d); })
            .catch(() => {});
    }, []);

    // Détecte si un numéro est un car Fluo
    const isFluoCar = (number) => {
        if (!data || !number) return false;
        const n = parseInt(number, 10);
        if (isNaN(n)) return false;
        const { regular, travaux } = data.cars;
        return (n >= regular.range[0] && n <= regular.range[1]) ||
               (n >= travaux.range[0] && n <= travaux.range[1]);
    };

    // Retourne le nombre de places réelles pour un car
    const getFluoCarSeats = (number) => {
        if (!data || !number) return 55;
        const n = parseInt(number, 10);
        if (isNaN(n)) return 55;
        const { regular, travaux } = data.cars;

        // Cherche dans les exceptions regular
        if (n >= regular.range[0] && n <= regular.range[1]) {
            for (const exc of regular.exceptions) {
                if (n >= exc.range[0] && n <= exc.range[1])
                    return exc.seats;
            }
            return regular.default_seats;
        }
        // Cherche dans les exceptions travaux
        if (n >= travaux.range[0] && n <= travaux.range[1]) {
            for (const exc of travaux.exceptions) {
                if (n >= exc.range[0] && n <= exc.range[1])
                    return exc.seats;
            }
            return travaux.default_seats;
        }
        return 55;
    };

    // Retourne l'URL du badge selon train ou car
    const getFluoBadgeUrl = (number) => {
        if (!data) return null;
        return isFluoCar(number)
            ? data.assets.badge_car
            : data.assets.badge_train;
    };

    // Retourne l'URL du picto selon train ou car
    const getFluoPictoUrl = (number) => {
        if (!data) return null;
        return isFluoCar(number)
            ? data.assets.picto_car
            : data.assets.picto_train;
    };

    return { isFluoCar, getFluoCarSeats, getFluoBadgeUrl, getFluoPictoUrl, loaded: !!data };
}
